import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../configApi";
import FileSaver from "file-saver";
const initialState = {
  isLoading: false,
  dataSatisticsNews: [],
  dataSatisticsProduct: [],
  dataSatisticsBanner: [],
  listTitlePost: [],
  dataReportViewPosts: {
    views: [],
    display: [],
  },
  dataReportTotalPosts: [],
  dataSatisticsMessage: [],
  dataSatisticsChartMessage: [],
  dataExportMessage: [],
};
const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //lấy data thông kế tin tức an ninh
      .addCase(getDataStatisticsNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDataStatisticsNews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataSatisticsNews = action.payload;
      })
      .addCase(getDataStatisticsNews.rejected, (state) => {
        state.isLoading = true;
      })
      //lấy data thông kế tình hình truy cập
      .addCase(getReportTotalPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReportTotalPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataReportTotalPosts = action.payload;
      })
      .addCase(getReportTotalPosts.rejected, (state) => {
        state.isLoading = true;
      })
      //lấy data thông kế tình hình truy cập
      .addCase(getReportViewPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReportViewPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action?.payload?.type === 1) {
          state.dataReportViewPosts.views = action?.payload?.data;
        } else {
          state.dataReportViewPosts.display = action?.payload?.data;
        }
      })
      .addCase(getReportViewPosts.rejected, (state) => {
        state.isLoading = true;
      })
      // lấy danh sách tiêu đề các bài viết
      .addCase(getListTitlePosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListTitlePosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listTitlePost = action.payload;
      })
      .addCase(getListTitlePosts.rejected, (state) => {
        state.isLoading = true;
      })
      //lấy data thống kê sản phẩm
      .addCase(getDataStatisticsProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDataStatisticsProduct.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataSatisticsProduct = action.payload;
      })
      .addCase(getDataStatisticsProduct.rejected, (state) => {
        state.isLoading = true;
      })
      //lấy data thống kê banner
      .addCase(getDataStatisticsBanner.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDataStatisticsBanner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataSatisticsBanner = action.payload;
      })
      .addCase(getDataStatisticsBanner.rejected, (state) => {
        state.isLoading = true;
      })

      //lấy data thống kê chat
      .addCase(getReportChat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReportChat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataSatisticsMessage = action.payload;
      })
      .addCase(getReportChat.rejected, (state) => {
        state.isLoading = true;
      })
      //lấy data thống kê chat chart
      .addCase(getReportLineChat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReportLineChat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataSatisticsChartMessage = action.payload;
      })
      .addCase(getReportLineChat.rejected, (state) => {
        state.isLoading = true;
      })

      //xuất excel thống kê chat
      .addCase(exportReportChat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(exportReportChat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataExportMessage = action.payload;
      })
      .addCase(exportReportChat.rejected, (state) => {
        state.isLoading = true;
      });
  },
});
export default statisticsSlice;
export const {} = statisticsSlice.actions;
export const getDataStatisticsNews = createAsyncThunk(
  "statistics/getDataStatisticsNews",
  async (body) => {
    let config = [];
    if (body.timeStart === "" && body.timeEnd === "") {
      config = {
        search: body.search,
        typeSort: body.typeSort,
        option: {
          limit: body.option.limit,
          offset: body.option.offset,
          order: "desc",
        },
        type: body.type,
      };
    } else {
      config = body;
    }
    try {
      const res = await instance.post(`/posts/views`, config);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getDataStatisticsProduct = createAsyncThunk(
  "statistics/getDataStatisticsProduct",
  async (config) => {
    try {
      const res = await instance.post(`/reportProduct/pageable`, config);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getDataStatisticsBanner = createAsyncThunk(
  "statistics/getDataStatisticsBanner",
  async (config) => {
    try {
      const res = await instance.post(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/reportBanner/pageable`,
        config,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const exportReportBanner = createAsyncThunk(
  "statistics/exportReportBanner",
  async (config) => {
    try {
      const res = await instance.post(
        `${window.SERVER_URL_ADS}/v1/api/adsAdmin/reportBanner/exportExcelDetailReportBanner`,
        config,
        {
          withCredentials:
            window.WITHCREDENTIAL !== "undefined"
              ? window.WITHCREDENTIAL
              : true,
        }
      );
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const exportReportProduct = createAsyncThunk(
  "statistics/exportReportProduct",
  async (config) => {
    try {
      const res = await instance.post(
        `/reportProduct/exportExcelReportProduct`,
        config
      );
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, "thongke.xlsx");
    } catch (error) {
      console.log(error);
    }
  }
);
export const getLogStatistics = createAsyncThunk(
  "statistics/getLogStatistics",
  async (id) => {
    try {
      const res = await instance.get(`newsLog/getLog/${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getListTitlePosts = createAsyncThunk(
  "statistics/getListTitlePosts",
  async (type) => {
    try {
      const res = await instance.get(`/posts/getTitlePosts?typePosts=${type}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getReportTotalPosts = createAsyncThunk(
  "statistics/getReportTotalPosts",
  async (config) => {
    try {
      const res = await instance.post(`/posts/reportTotalPosts`, config);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getReportViewPosts = createAsyncThunk(
  "statistics/getReportViewPosts",
  async (config) => {
    try {
      const res = await instance.post(`/posts/reportViewPosts`, config);
      const result = res.data;
      return {
        data: result.data,
        type: config.typeField,
      };
    } catch (error) {
      console.log(error);
    }
  }
);
export const getReportChat = createAsyncThunk(
  "statistics/getReportChat",
  async ({ timeStart, timeEnd, size, page }) => {
    try {
      const res = await instance.get(
        // `/message-statistics/weekly?startDate=${1744619697}&endDate=${1757838897}&page=${page}&size=${size}`
        `/message-statistics?startDate=${timeStart}&endDate=${timeEnd}&page=${page}&size=${size}`
      );
      const result = res.data.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getReportLineChat = createAsyncThunk(
  "statistics/getReportLineChat",
  async ({ timeStart, timeEnd }) => {
    try {
      const res = await instance.get(
        // `/message-statistics/report?startDate=${1744619697}&endDate=${1757838897}`
        `/message-statistics/report?startDate=${timeStart}&endDate=${timeEnd}`
      );
      const result = res.data.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
export const exportReportChat = createAsyncThunk(
  "statistics/exportReportChat",
  async ({ timeStart, timeEnd }) => {
    try {
      const res = await instance.get(
        // `/message-statistics/weekly?startDate=${1744619697}&endDate=${1757838897}`,
        `/message-statistics/export?startDate=${timeStart}&endDate=${timeEnd}`,
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, "thongkeChat.xlsx");
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
